import axiosClient from "./axiosClient";
import { useSelector } from "react-redux";
import uploadApi from "./uploadImage";
const storeApi = {
  async registerStore(data) {
    const url = `/stores`;
    return axiosClient.post(url, data);
  },
  async getDetail(id) {
    const url = `/stores/${id}`;
    return axiosClient.get(url);
  },
  async getProduct(id, page, size) {
    const url = `/products/all-paging?store_id=${id}&page_index=${page}&page_size=${size}`;
    return axiosClient.get(url);
  },
  async getProductById(id) {
    const url = `/products/${id}`;
    return axiosClient.get(url);
  },
  async getMyStore() {
    const url = `/stores/my-store`;
    return axiosClient.get(url);
  },
  async storeGetProduct(data) {
    const url = `products/all-paging?&page_index=${data?.page}&page_size=10&store_id=${data?.id}`;
    return axiosClient.get(url);
  },

  async storeDeleteProduct(id) {
    const url = `products/${id}`;
    return axiosClient.delete(url);
  },

  async storeEditProduct(id, data) {
    const url = `products/${id}`;
    // async uploadApi();
    return axiosClient.put(url, data);
  },

  async getOrderByStore(id) {
    const url = `/orders/my-orders-store/${id}`;
    return axiosClient.get(url);
  },

  async storeCreateProduct(data) {
    const url = `/products`;
    return axiosClient.post(url, data);
  },

  async updateStore(id, data) {
    const url = `/stores/${id}`;
    return axiosClient.put(url, data);
  },
};

export default storeApi;
